import {useState} from "react"
import searchIcon from "../assets/search.svg"

export default function Searcher({placeholder,keyword,setKeyword}){

    const [inputVal,setInputVal]=useState(keyword)

    const handleKeyDown=event=>{
        if(event.key==="Enter" && inputVal.length>=3){
            setKeyword(inputVal)
        }
    }

    return(
        <div className="searcher">
            <input className="searcher-box" type="text" value={inputVal} onChange={e=>setInputVal(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholder} />
            <div className="searcher-icon"><img src={searchIcon} /></div>
        </div>
    )

}